<template>
  <div class="playback-play-button">
    <span class="tooltip">
      <span class="material-icons play-icon" @click="onClick">{{
        iconName
      }}</span>
      <span class="description-top" :style="descriptionStyle">
        {{ description }}
      </span>
    </span>
  </div>
</template>

<script>
import C from "../../Constants";
export default {
  name: "PlaybackSpeedButton",
  components: {},
  props: ["playbackStatus"],
  data() {
    return {
      mPlaybackStatus: C.PLAYBACK_STATUS.PAUSE,
      descriptionStyle: {
        width: "10em",
      },
    };
  },
  watch: {
    playbackStatus(v) {
      if (typeof v !== "undefined") {
        this.mPlaybackStatus = v;
      }
    },
    description() {
      if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PAUSE) {
        this.descriptionStyle.width = "5em";
      } else if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PLAY) {
        this.descriptionStyle.width = "7em";
      } else {
        this.descriptionStyle.width = "10em";
      }
    },
  },
  computed: {
    iconName() {
      if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PAUSE) {
        return "play_arrow";
      } else if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PLAY) {
        return "pause";
      } else {
        return "replay";
      }
    },
    description() {
      if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PAUSE) {
        return "再生";
      } else if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PLAY) {
        return "一時停止";
      } else {
        return "もう一度再生する";
      }
    },
  },
  methods: {
    onClick() {
      if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PLAY) {
        this.$emit("pause");
      } else if (this.mPlaybackStatus === C.PLAYBACK_STATUS.PAUSE) {
        this.$emit("play");
      } else {
        this.$emit("rePlay");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.playback-play-button {
  .play-icon {
    color: $aisea-white;
    font-size: 48px;
  }

  .tooltip {
    position: relative;
    cursor: pointer;
    padding: 0 5px;
    font-size: 0.9em;
    color: #4682b4;
  }

  .description-top {
    display: none;
    position: absolute;
    padding: 10px;
    font-size: 12px;
    line-height: 1.6em;
    color: $aisea-white;
    border-radius: 5px;
    background: #000;
    width: 10em;
    text-align: center;
  }

  .tooltip:hover .description-top {
    display: inline-block;
    top: -85px;
    left: -12px;
  }
}
</style>
